import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerTextingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomerTextingQuery = { __typename?: 'Query', customerTexting: { __typename?: 'CustomerTextingData', state: Types.CustomerTextingState, phoneNumber?: string | null, submittedOn?: string | null } };


export const GetCustomerTextingDocument = new TypedDocumentString(`
    query GetCustomerTexting {
  customerTexting {
    state
    phoneNumber
    submittedOn
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerTexting: build.query<GetCustomerTextingQuery, GetCustomerTextingQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerTextingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerTextingQuery, useLazyGetCustomerTextingQuery } = injectedRtkApi;
